var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{staticClass:"pa-0",attrs:{"dense":!_vm.AppIsSmall,"flat":"","tile":""}},[_vm._l((_vm.items),function(item,i){return [_c('app-list-item',{key:`list-item-${i.toString()}`,attrs:{"item":item}})]}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }